import { IconName } from '@core/user-interface-legacy';

export enum ChurnReason {
  TooComplicated = 'too_complicated',
  MissingFeatures = 'missing_features',
  MovingToAnotherTool = 'moving_to_another_tool',
  OrganizationalChanges = 'organizational_changes',
  NotHiring = 'not_hiring',
  TooExpensive = 'too_expensive',
  UnhelpfulSupport = 'insufficient_support',
  Other = 'other',
}

export interface ChurnReasonI {
  id: ChurnReason;
  label: string;
  description: string;
  iconName: IconName;
}

export type ChurnFlowSolutionIconVariant =
  | 'assignment'
  | 'block'
  | 'currency-exchange'
  | 'dialog'
  | 'help'
  | 'lightbulb'
  | 'pause-subscription'
  | 'performance-management'
  | 'roadmap'
  | 'tellent'
  | 'tellent-hr'
  | 'training'
  | 'whatsapp-hiring'
  | 'workflow-automation';

export interface ChurnFlowSolutionCardI {
  iconVariant: ChurnFlowSolutionIconVariant;
  title: string;
  subtitle?: string;
  incentives: string[];
  ctaText: string;
  secondaryCtaText?: string;
}

export interface SubscriptionEndDateI {
  endDate: string;
  latestCancellationDate: string;
}

export interface ChurnFlowCancelPayload {
  reasonForLeaving: ChurnReason;
}

export interface ChurnFlowTestimonial {
  text: string;
  avatarSrc: string;
  name: string;
  role: string;
}

export interface ChurnFlowInsightI {
  icon: IconName;
  label: string;
  title?: string;
  tooltip?: string;
  value: string;
}

export enum ChurnFlowSupportedLocale {
  German = 'de',
  French = 'fr',
  Dutch = 'nl',
  RestOfWorld = 'en',
}

export type ChurnFlowAnalyticsI = {
  app?: ChurnFlowAnalyticsApp;
  step?: string;
  reason?: ChurnReason;
};

export type ChurnFlowAnalyticsApp = 'recruitee' | 'one-settings';
